<template>
  <div class="d-flex align-items-center justify-content-between">
    <div class="w-100">
      <div class="date-picker-wrapper">
        <DatePickerV2 />
      </div>
    </div>

    <!-- Vertical Line -->
    <div class="vertical-line"></div>

    <div class="w-100">
      <div class="ml-lg-3">
        <Participants
          @changeOpenParticipants="handleChangeOpenParticipants"
          @setParticipants="handleSetParticipants"
          @notEnoughAdults="handleNotEnoughAdults"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  // Store
  // import store from '@/vue/planning/store/store'
  import DatePickerV2 from '@/vue/planning/components/search/DatePickerV2.vue'
  import Participants from '@/vue/planning/components/search/participants.vue'
  import { useStore } from 'vuex'
  const store = useStore()

  const handleChangeOpenParticipants = (bool: boolean) => {
    store.dispatch('setParticipantsDropdownOpen', bool)
  }

  const handleSetParticipants = (newArray: Array<unknown>) => {
    store.dispatch('setParticipants', newArray)
  }

  const handleNotEnoughAdults = () => {
    store.commit('setErrorMessageOpen', 'errorMessages_notEnoughAdults')
  }
</script>

<style scoped>
  .vertical-line {
    width: 2px; /* Adjust thickness */
    height: 40px; /* Adjust height as needed */
    background-color: #ced4da; /* Adjust color */
    margin: 0 16px; /* Space between elements */
  }
  .date-picker-wrapper {
   position: relative;
   overflow: visible !important;
 }
</style>
